import { useCallback } from 'react';
import makeLink from 'helper/make-link';
import type { RouteDefinition } from 'core/routing/types';
import { useDispatch } from 'store/hooks';
import { push } from 'connected-react-router';

const useGoTo = (route: RouteDefinition, absolute = false) => {
  const dispatch = useDispatch();

  return useCallback((params: object = {}) => dispatch(push(makeLink(route, params, absolute))), [route, absolute]);
};

export default useGoTo;
